const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcomeIntelzbot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.073,
    height: 54.674,
    viewBox: "0 0 53.073 54.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204828",
    transform: "translate(43.487 24.221)",
    style: {
      fill: "#5996ef"
    },
    d: "M0 0h2.206v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204829",
    transform: "translate(43.487 22.016)",
    style: {
      fill: "#5996ef"
    },
    d: "M0 0h2.206v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204830",
    transform: "translate(41.277 26.43)",
    style: {
      fill: "#5996ef"
    },
    d: "M0 0h2.21v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204831",
    transform: "translate(41.277 24.221)",
    style: {
      fill: "#5996ef"
    },
    d: "M0 0h2.21v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204832",
    transform: "translate(41.277 22.016)",
    style: {
      fill: "#5996ef"
    },
    d: "M0 0h2.21v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204833",
    transform: "translate(41.277 19.934)",
    style: {
      fill: "#5996ef"
    },
    d: "M0 0h2.21v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204834",
    transform: "translate(39.072 30.844)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.206v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204835",
    transform: "translate(39.072 28.635)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.206v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204836",
    transform: "translate(39.072 26.43)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.206v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204837",
    transform: "translate(39.072 24.221)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.206v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204838",
    transform: "translate(39.072 22.016)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.206v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204839",
    transform: "translate(39.072 19.807)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.206v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204840",
    transform: "translate(39.072 17.602)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.206v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204841",
    transform: "translate(36.863 33.049)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.209v2.244H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204842",
    transform: "translate(36.863 30.844)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.209v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204843",
    transform: "translate(36.863 28.635)",
    style: {
      fill: "#efcb97"
    },
    d: "M0 0h2.209v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204844",
    transform: "translate(36.863 26.43)",
    style: {
      fill: "#efcb97"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204845",
    transform: "translate(36.863 24.221)",
    style: {
      fill: "#efcb97"
    },
    d: "M0 0h2.209v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204846",
    transform: "translate(36.863 22.016)",
    style: {
      fill: "#efcb97"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204847",
    transform: "translate(36.863 19.807)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.209v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204848",
    transform: "translate(36.863 17.602)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204849",
    transform: "translate(36.863 15.391)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.209v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204850",
    transform: "translate(34.639 33.049)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.225v2.244H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204851",
    transform: "translate(34.639 30.844)",
    style: {
      fill: "#efcb97"
    },
    d: "M0 0h2.225v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204852",
    transform: "translate(34.639 28.635)",
    style: {
      fill: "#efcb97"
    },
    d: "M0 0h2.225v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204853",
    transform: "translate(34.639 26.43)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.225v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204854",
    transform: "translate(34.639 24.221)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.225v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204855",
    transform: "translate(34.639 22.016)",
    style: {
      fill: "#191919"
    },
    d: "M0 0h2.225v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204856",
    transform: "translate(34.639 19.807)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.225v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204857",
    transform: "translate(34.639 17.602)",
    style: {
      fill: "#ffebca"
    },
    d: "M0 0h2.225v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204858",
    transform: "translate(34.639 15.391)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.225v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204859",
    transform: "translate(32.43 33.049)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.21v2.244H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204860",
    transform: "translate(32.43 30.844)",
    style: {
      fill: "#efcb97"
    },
    d: "M0 0h2.21v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204861",
    transform: "translate(32.43 28.635)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.21v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204862",
    transform: "translate(32.43 26.43)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.21v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204863",
    transform: "translate(32.43 24.221)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.21v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204864",
    transform: "translate(32.43 22.016)",
    style: {
      fill: "#191919"
    },
    d: "M0 0h2.21v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204865",
    transform: "translate(32.43 19.807)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.21v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204866",
    transform: "translate(34.639 24.096)",
    style: {
      fill: "#191919"
    },
    d: "M0 0h2.225v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204867",
    transform: "translate(34.639 21.887)",
    style: {
      fill: "#191919"
    },
    d: "M0 0h2.225v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204868",
    transform: "translate(32.43 24.096)",
    style: {
      fill: "#191919"
    },
    d: "M0 0h2.21v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204869",
    transform: "translate(32.43 21.887)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h2.21v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204870",
    transform: "translate(32.43 17.602)",
    style: {
      fill: "#ffebca"
    },
    d: "M0 0h2.21v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204871",
    transform: "translate(32.43 15.391)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.21v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204872",
    transform: "translate(30.225 33.049)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.205v2.244H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204873",
    transform: "translate(30.225 30.844)",
    style: {
      fill: "#efcb97"
    },
    d: "M0 0h2.205v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204874",
    transform: "translate(30.225 28.635)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.205v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204875",
    transform: "translate(30.225 26.43)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.205v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204876",
    transform: "translate(30.225 24.221)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.205v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204877",
    transform: "translate(30.225 22.016)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.205v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204878",
    transform: "translate(30.225 19.807)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.205v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204879",
    transform: "translate(30.225 17.602)",
    style: {
      fill: "#ffebca"
    },
    d: "M0 0h2.205v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204880",
    transform: "translate(30.225 15.391)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.205v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204881",
    transform: "translate(28.016 33.049)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.21v2.244H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204882",
    transform: "translate(28.016 30.844)",
    style: {
      fill: "#efcb97"
    },
    d: "M0 0h2.21v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204883",
    transform: "translate(28.016 28.635)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.21v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204884",
    transform: "translate(28.016 26.43)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.21v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204885",
    transform: "translate(28.016 24.221)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.21v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204886",
    transform: "translate(28.016 22.016)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.21v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204887",
    transform: "translate(28.016 19.807)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.21v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204888",
    transform: "translate(28.016 17.602)",
    style: {
      fill: "#ffebca"
    },
    d: "M0 0h2.21v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204889",
    transform: "translate(28.016 15.391)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.21v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204890",
    transform: "translate(25.811 33.049)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.206v2.244H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204891",
    transform: "translate(25.811 30.844)",
    style: {
      fill: "#efcb97"
    },
    d: "M0 0h2.206v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204892",
    transform: "translate(25.811 28.635)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.206v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204893",
    transform: "translate(25.811 26.43)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.206v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204894",
    transform: "translate(25.811 24.221)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.206v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204895",
    transform: "translate(25.811 22.016)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.206v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204896",
    transform: "translate(25.811 19.807)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.206v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204897",
    transform: "translate(25.811 17.602)",
    style: {
      fill: "#fff2d9"
    },
    d: "M0 0h2.206v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204898",
    transform: "translate(25.811 15.391)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.206v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204899",
    transform: "translate(23.602 33.049)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.209v2.244H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204900",
    transform: "translate(23.602 30.844)",
    style: {
      fill: "#efcb97"
    },
    d: "M0 0h2.209v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204901",
    transform: "translate(23.602 28.635)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.209v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204902",
    transform: "translate(23.602 26.43)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204903",
    transform: "translate(23.602 24.221)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.209v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204904",
    transform: "translate(23.602 22.016)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204905",
    transform: "translate(23.602 19.807)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.209v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204906",
    transform: "translate(23.602 17.602)",
    style: {
      fill: "#fff2d9"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204907",
    transform: "translate(23.602 15.391)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.209v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204908",
    transform: "translate(21.396 33.049)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.206v2.244H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204909",
    transform: "translate(21.396 30.844)",
    style: {
      fill: "#efcb97"
    },
    d: "M0 0h2.206v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204910",
    transform: "translate(21.396 28.635)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.206v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204911",
    transform: "translate(21.396 26.43)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.206v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204912",
    transform: "translate(21.396 24.221)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.206v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204913",
    transform: "translate(21.396 22.016)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.206v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204914",
    transform: "translate(21.396 19.807)",
    style: {
      fill: "#ffebca"
    },
    d: "M0 0h2.206v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204915",
    transform: "translate(21.396 17.602)",
    style: {
      fill: "#fff2d9"
    },
    d: "M0 0h2.206v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204916",
    transform: "translate(21.396 15.391)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.206v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204917",
    transform: "translate(19.187 33.049)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.21v2.244H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204918",
    transform: "translate(19.187 30.844)",
    style: {
      fill: "#efcb97"
    },
    d: "M0 0h2.21v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204919",
    transform: "translate(19.187 28.635)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.21v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204920",
    transform: "translate(19.187 26.43)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.21v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204921",
    transform: "translate(19.187 24.221)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.21v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204922",
    transform: "translate(19.187 22.016)",
    style: {
      fill: "#191919"
    },
    d: "M0 0h2.21v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204923",
    transform: "translate(19.187 19.807)",
    style: {
      fill: "#fff2d9"
    },
    d: "M0 0h2.21v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204924",
    transform: "translate(19.187 17.602)",
    style: {
      fill: "#fff2d9"
    },
    d: "M0 0h2.21v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204925",
    transform: "translate(19.187 15.391)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.21v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204926",
    transform: "translate(16.962 33.049)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.224v2.244H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204927",
    transform: "translate(16.962 30.844)",
    style: {
      fill: "#efcb97"
    },
    d: "M0 0h2.224v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204928",
    transform: "translate(16.962 28.635)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.224v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204929",
    transform: "translate(16.962 26.43)",
    style: {
      fill: "#f7dcb5"
    },
    d: "M0 0h2.224v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204930",
    transform: "translate(16.962 24.221)",
    style: {
      fill: "#ffebca"
    },
    d: "M0 0h2.224v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204931",
    transform: "translate(16.962 22.016)",
    style: {
      fill: "#191919"
    },
    d: "M0 0h2.224v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204932",
    transform: "translate(16.962 19.807)",
    style: {
      fill: "#fff2d9"
    },
    d: "M0 0h2.224v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204933",
    transform: "translate(19.187 24.096)",
    style: {
      fill: "#191919"
    },
    d: "M0 0h2.21v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204934",
    transform: "translate(19.187 21.887)",
    style: {
      fill: "#191919"
    },
    d: "M0 0h2.21v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204935",
    transform: "translate(16.962 24.096)",
    style: {
      fill: "#191919"
    },
    d: "M0 0h2.224v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204936",
    transform: "translate(16.962 21.887)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h2.224v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204937",
    transform: "translate(16.962 17.602)",
    style: {
      fill: "#fff2d9"
    },
    d: "M0 0h2.224v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204938",
    transform: "translate(16.962 15.391)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.224v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204939",
    transform: "translate(34.639 13.311)",
    style: {
      fill: "#ccc"
    },
    d: "M0 0h2.225v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204940",
    transform: "translate(32.43 13.311)",
    style: {
      fill: "#ccc"
    },
    d: "M0 0h2.21v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204941",
    transform: "translate(30.225 13.311)",
    style: {
      fill: "#ccc"
    },
    d: "M0 0h2.205v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204942",
    transform: "translate(28.016 13.311)",
    style: {
      fill: "#ccc"
    },
    d: "M0 0h2.21v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204943",
    transform: "translate(25.811 13.311)",
    style: {
      fill: "#ccc"
    },
    d: "M0 0h2.206v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204944",
    transform: "translate(23.602 13.311)",
    style: {
      fill: "#ccc"
    },
    d: "M0 0h2.209v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204945",
    transform: "translate(21.396 13.311)",
    style: {
      fill: "#ccc"
    },
    d: "M0 0h2.206v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204946",
    transform: "translate(19.187 13.311)",
    style: {
      fill: "#ccc"
    },
    d: "M0 0h2.21v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204947",
    transform: "translate(16.962 13.311)",
    style: {
      fill: "#ccc"
    },
    d: "M0 0h2.224v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204948",
    transform: "translate(14.753 33.049)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.209v2.244H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204949",
    transform: "translate(14.753 30.844)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.209v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204950",
    transform: "translate(14.753 28.635)",
    style: {
      fill: "#ffebca"
    },
    d: "M0 0h2.209v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204951",
    transform: "translate(14.753 26.43)",
    style: {
      fill: "#ffebca"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204952",
    transform: "translate(14.753 24.221)",
    style: {
      fill: "#ffebca"
    },
    d: "M0 0h2.209v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204953",
    transform: "translate(14.753 22.016)",
    style: {
      fill: "#ffebca"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204954",
    transform: "translate(14.753 19.807)",
    style: {
      fill: "#fff2d9"
    },
    d: "M0 0h2.209v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204955",
    transform: "translate(14.753 17.602)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204956",
    transform: "translate(19.187 11.07)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204957",
    transform: "translate(17.106 8.988)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204958",
    transform: "translate(15.024 6.906)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204959",
    transform: "translate(25.432 11.07)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204960",
    transform: "translate(25.432 8.988)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204961",
    transform: "translate(25.432 6.906)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204962",
    transform: "translate(32.43 11.07)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204963",
    transform: "translate(34.511 8.988)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204964",
    transform: "translate(36.593 6.906)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204965",
    transform: "translate(14.753 15.391)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.209v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204966",
    transform: "translate(12.548 30.844)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.206v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204967",
    transform: "translate(12.548 28.635)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.206v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204968",
    transform: "translate(12.548 26.43)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.206v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204969",
    transform: "translate(12.548 24.221)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.206v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204970",
    transform: "translate(12.548 22.016)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.206v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204971",
    transform: "translate(12.548 19.807)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.206v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204972",
    transform: "translate(12.548 17.602)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.206v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204973",
    transform: "translate(10.339 26.43)",
    style: {
      fill: "#5996ef"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204974",
    transform: "translate(10.339 24.221)",
    style: {
      fill: "#5996ef"
    },
    d: "M0 0h2.209v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204975",
    transform: "translate(10.339 22.016)",
    style: {
      fill: "#5996ef"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204976",
    transform: "translate(10.339 19.934)",
    style: {
      fill: "#5996ef"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204977",
    transform: "translate(8.133 24.221)",
    style: {
      fill: "#5996ef"
    },
    d: "M0 0h2.206v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204978",
    transform: "translate(8.133 22.016)",
    style: {
      fill: "#5996ef"
    },
    d: "M0 0h2.206v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204979",
    transform: "translate(29.97 35.127)",
    style: {
      fill: "#3f4547"
    },
    d: "M0 0h2.21v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204980",
    transform: "translate(27.78 35.127)",
    style: {
      fill: "#3f4547"
    },
    d: "M0 0h2.21v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204981",
    transform: "translate(25.63 35.127)",
    style: {
      fill: "#3f4547"
    },
    d: "M0 0h2.206v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204982",
    transform: "translate(23.421 35.127)",
    style: {
      fill: "#3f4547"
    },
    d: "M0 0h2.209v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204983",
    transform: "translate(21.241 35.127)",
    style: {
      fill: "#3f4547"
    },
    d: "M0 0h2.21v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204984",
    transform: "translate(35.364 45.896)",
    style: {
      fill: "#4c86cc"
    },
    d: "M0 0h2.209v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204985",
    transform: "translate(35.364 43.729)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.209v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204986",
    transform: "translate(35.364 41.523)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204987",
    transform: "translate(35.364 39.314)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.209v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204988",
    transform: "translate(33.139 48.105)",
    style: {
      fill: "#3675c1"
    },
    d: "M0 0h2.225v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204989",
    transform: "translate(33.139 45.896)",
    style: {
      fill: "#4c86cc"
    },
    d: "M0 0h2.225v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204990",
    transform: "translate(33.139 43.729)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.225v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204991",
    transform: "translate(33.139 41.523)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.225v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204992",
    transform: "translate(33.139 39.314)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.225v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204993",
    transform: "translate(33.139 37.109)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.225v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204994",
    transform: "translate(30.93 48.105)",
    style: {
      fill: "#3675c1"
    },
    d: "M0 0h2.21v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204995",
    transform: "translate(30.93 45.896)",
    style: {
      fill: "#4c86cc"
    },
    d: "M0 0h2.21v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204996",
    transform: "translate(30.93 43.729)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.21v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204997",
    transform: "translate(30.93 41.523)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.21v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204998",
    transform: "translate(30.93 39.314)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.21v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 204999",
    transform: "translate(30.93 37.109)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.21v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205000",
    transform: "translate(28.726 48.105)",
    style: {
      fill: "#3675c1"
    },
    d: "M0 0h2.205v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205001",
    transform: "translate(28.726 45.896)",
    style: {
      fill: "#4c86cc"
    },
    d: "M0 0h2.205v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205002",
    transform: "translate(28.726 43.729)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.205v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205003",
    transform: "translate(28.726 41.523)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.205v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205004",
    transform: "translate(28.726 39.314)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.205v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205005",
    transform: "translate(28.726 37.109)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.205v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205006",
    transform: "translate(26.517 48.105)",
    style: {
      fill: "#3675c1"
    },
    d: "M0 0h2.21v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205007",
    transform: "translate(26.517 45.896)",
    style: {
      fill: "#4c86cc"
    },
    d: "M0 0h2.21v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205008",
    transform: "translate(26.517 43.729)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.21v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205009",
    transform: "translate(26.517 41.523)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.21v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205010",
    transform: "translate(26.517 39.314)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.21v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205011",
    transform: "translate(26.517 37.109)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.21v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205012",
    transform: "translate(24.308 48.105)",
    style: {
      fill: "#3675c1"
    },
    d: "M0 0h2.209v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205013",
    transform: "translate(24.308 45.896)",
    style: {
      fill: "#4c86cc"
    },
    d: "M0 0h2.209v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205014",
    transform: "translate(24.308 43.729)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.209v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205015",
    transform: "translate(24.308 41.523)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205016",
    transform: "translate(24.308 39.314)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.209v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205017",
    transform: "translate(24.308 37.109)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.209v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205018",
    transform: "translate(22.102 48.105)",
    style: {
      fill: "#3675c1"
    },
    d: "M0 0h2.206v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205019",
    transform: "translate(22.102 45.896)",
    style: {
      fill: "#4c86cc"
    },
    d: "M0 0h2.206v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205020",
    transform: "translate(22.102 43.729)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.206v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205021",
    transform: "translate(22.102 41.523)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.206v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205022",
    transform: "translate(22.102 39.314)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.206v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205023",
    transform: "translate(22.102 37.109)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.206v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205024",
    transform: "translate(19.893 48.105)",
    style: {
      fill: "#3675c1"
    },
    d: "M0 0h2.21v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205025",
    transform: "translate(19.893 45.896)",
    style: {
      fill: "#4c86cc"
    },
    d: "M0 0h2.21v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205026",
    transform: "translate(19.893 43.729)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.21v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205027",
    transform: "translate(19.893 41.523)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.21v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205028",
    transform: "translate(19.893 39.314)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.21v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205029",
    transform: "translate(19.893 37.109)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.21v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205030",
    transform: "translate(17.669 48.105)",
    style: {
      fill: "#3675c1"
    },
    d: "M0 0h2.224v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205031",
    transform: "translate(17.669 45.896)",
    style: {
      fill: "#4c86cc"
    },
    d: "M0 0h2.224v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205032",
    transform: "translate(17.669 43.729)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.224v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205033",
    transform: "translate(17.669 41.523)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.224v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205034",
    transform: "translate(17.669 39.314)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.224v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205035",
    transform: "translate(17.669 37.109)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.224v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205036",
    transform: "translate(15.46 45.896)",
    style: {
      fill: "#4c86cc"
    },
    d: "M0 0h2.209v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205037",
    transform: "translate(15.46 43.729)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.209v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205038",
    transform: "translate(15.46 41.523)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205039",
    transform: "translate(15.46 39.314)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.209v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205040",
    transform: "translate(23.355 52.469)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.21v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205041",
    transform: "translate(21.131 52.469)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.224v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205042",
    transform: "translate(21.131 50.26)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.224v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205043",
    transform: "translate(18.923 52.469)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.208v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205044",
    transform: "translate(18.923 50.26)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.209v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205045",
    transform: "translate(16.717 52.469)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.206v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205046",
    transform: "translate(34.054 52.469)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.21v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205047",
    transform: "translate(31.83 52.469)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.224v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205048",
    transform: "translate(31.83 50.26)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.224v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205049",
    transform: "translate(29.621 52.469)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.209v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205050",
    transform: "translate(29.621 50.26)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.209v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205051",
    transform: "translate(27.415 52.469)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.206v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205052",
    transform: "translate(13.24 41.561)",
    style: {
      fill: "#3f4547"
    },
    d: "M0 0h2.206v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205053",
    transform: "translate(13.24 39.352)",
    style: {
      fill: "#3f4547"
    },
    d: "M0 0h2.206v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205054",
    transform: "translate(11.031 41.561)",
    style: {
      fill: "#245ea3"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205055",
    transform: "translate(11.031 39.352)",
    style: {
      fill: "#4c86cc"
    },
    d: "M0 0h2.209v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205056",
    transform: "translate(8.825 43.766)",
    style: {
      fill: "#245ea3"
    },
    d: "M0 0h2.206v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205057",
    transform: "translate(8.825 41.561)",
    style: {
      fill: "#4c86cc"
    },
    d: "M0 0h2.206v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205058",
    transform: "translate(6.616 43.766)",
    style: {
      fill: "#4c86cc"
    },
    d: "M0 0h2.21v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205059",
    transform: "translate(37.588 41.561)",
    style: {
      fill: "#3f4547"
    },
    d: "M0 0h2.206v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205060",
    transform: "translate(37.588 39.352)",
    style: {
      fill: "#3f4547"
    },
    d: "M0 0h2.206v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205061",
    transform: "translate(39.792 41.561)",
    style: {
      fill: "#245ea3"
    },
    d: "M0 0h2.209v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205062",
    transform: "translate(39.792 39.352)",
    style: {
      fill: "#4c86cc"
    },
    d: "M0 0h2.209v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205063",
    transform: "translate(42.002 43.766)",
    style: {
      fill: "#245ea3"
    },
    d: "M0 0h2.206v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205064",
    transform: "translate(42.002 41.561)",
    style: {
      fill: "#4c86cc"
    },
    d: "M0 0h2.206v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205065",
    transform: "translate(44.207 43.766)",
    style: {
      fill: "#4c86cc"
    },
    d: "M0 0h2.21v2.209H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205066",
    transform: "translate(6.661 48.203)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.206v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205067",
    transform: "translate(4.452 50.408)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.21v2.244H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205068",
    transform: "translate(4.452 48.203)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.21v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205069",
    transform: "translate(6.661 45.994)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.206v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205070",
    transform: "translate(4.453 45.994)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.209v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205071",
    transform: "translate(4.453 43.789)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.209v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205072",
    transform: "translate(2.21 45.994)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.224v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205073",
    transform: "translate(2.229 43.789)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.224v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205074",
    transform: "rotate(-.243 11887.022 -499.416)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.21v2.244H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205075",
    transform: "rotate(-.243 11366.645 -500.755)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.21v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205076",
    transform: "translate(0 46.004)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.21v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205077",
    transform: "rotate(-.263 10503.412 23.017)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.206v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205078",
    transform: "translate(44.207 48.162)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.206v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205079",
    transform: "translate(46.412 50.367)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.21v2.244H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205080",
    transform: "translate(46.412 48.162)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.21v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205081",
    transform: "translate(44.207 45.953)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.206v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205082",
    transform: "translate(46.412 45.953)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.209v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205083",
    transform: "translate(46.412 43.748)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.209v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205084",
    transform: "rotate(-89.77 48.489 -.336)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.21v2.224H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205085",
    transform: "translate(48.622 43.748)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.224v2.205H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205086",
    transform: "rotate(-89.77 50.722 1.888)",
    style: {
      fill: "#606060"
    },
    d: "M0 0h2.244v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205087",
    transform: "rotate(-89.757 49.6 .76)",
    style: {
      fill: "#8e8e8e"
    },
    d: "M0 0h2.205v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205088",
    transform: "rotate(-89.77 49.604 -1.448)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.21v2.21H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205089",
    transform: "rotate(-89.77 50.711 -.346)",
    style: {
      fill: "#b7b7b7"
    },
    d: "M0 0h2.205v2.206H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205090",
    transform: "translate(23.287 26.969)",
    style: {
      fill: "#343b46"
    },
    d: "M0 0h1.511v1.511H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205091",
    transform: "translate(28.698 26.969)",
    style: {
      fill: "#343b46"
    },
    d: "M0 0h1.511v1.511H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205092",
    transform: "translate(24.536 28.219)",
    style: {
      fill: "#343b46"
    },
    d: "M0 0h1.511v1.511H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205093",
    transform: "translate(26.031 28.219)",
    style: {
      fill: "#343b46"
    },
    d: "M0 0h1.511v1.511H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205094",
    transform: "translate(27.488 28.219)",
    style: {
      fill: "#343b46"
    },
    d: "M0 0h1.511v1.511H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205095",
    transform: "translate(12.652 2.08)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205096",
    transform: "translate(13.854 2.08)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205097",
    transform: "translate(15.057 3.283)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205098",
    transform: "translate(16.258 4.484)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205099",
    transform: "translate(16.258 5.688)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205100",
    transform: "translate(15.057 6.889)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205101",
    transform: "translate(11.45 3.283)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205102",
    transform: "translate(12.652 3.283)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205103",
    transform: "translate(13.854 3.283)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205104",
    transform: "translate(15.057 4.484)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205105",
    transform: "translate(11.45 4.484)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205106",
    transform: "translate(12.652 4.484)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205107",
    transform: "translate(13.854 4.484)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205108",
    transform: "translate(15.057 5.688)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205109",
    transform: "translate(11.45 5.688)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205110",
    transform: "translate(12.652 5.688)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205111",
    transform: "translate(13.854 5.688)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205112",
    transform: "translate(12.652 6.889)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205113",
    transform: "translate(13.854 6.889)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205114",
    transform: "translate(10.249 4.484)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205115",
    transform: "translate(10.249 5.688)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205116",
    transform: "translate(11.45 6.889)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205117",
    transform: "translate(12.652 8.09)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205118",
    transform: "translate(13.854 8.09)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205119",
    transform: "translate(38.461 2.08)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205120",
    transform: "translate(39.663 2.08)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205121",
    transform: "translate(40.864 3.283)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205122",
    transform: "translate(42.066 4.484)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205123",
    transform: "translate(42.066 5.688)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205124",
    transform: "translate(40.864 6.889)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205125",
    transform: "translate(37.259 3.283)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205126",
    transform: "translate(38.461 3.283)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205127",
    transform: "translate(39.663 3.283)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205128",
    transform: "translate(40.864 4.484)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205129",
    transform: "translate(37.259 4.484)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205130",
    transform: "translate(38.461 4.484)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205131",
    transform: "translate(39.663 4.484)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205132",
    transform: "translate(40.864 5.688)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205133",
    transform: "translate(37.259 5.688)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205134",
    transform: "translate(38.461 5.688)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205135",
    transform: "translate(39.663 5.688)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205136",
    transform: "translate(38.461 6.889)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205137",
    transform: "translate(39.663 6.889)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205138",
    transform: "translate(36.057 4.484)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205139",
    transform: "translate(36.057 5.688)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205140",
    transform: "translate(37.259 6.889)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205141",
    transform: "translate(38.461 8.09)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205142",
    transform: "translate(39.663 8.09)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205143",
    transform: "translate(25.425)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205144",
    transform: "translate(26.626)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205145",
    transform: "translate(27.828 1.201)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205146",
    transform: "translate(29.03 2.404)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205147",
    transform: "translate(29.03 3.605)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205148",
    transform: "translate(27.828 4.807)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205149",
    transform: "translate(24.223 1.201)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205150",
    transform: "translate(25.425 1.201)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205151",
    transform: "translate(26.626 1.201)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205152",
    transform: "translate(27.828 2.404)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205153",
    transform: "translate(24.223 2.404)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205154",
    transform: "translate(25.425 2.404)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205155",
    transform: "translate(26.626 2.404)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205156",
    transform: "translate(27.828 3.605)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205157",
    transform: "translate(24.223 3.605)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205158",
    transform: "translate(25.425 3.605)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205159",
    transform: "translate(26.626 3.605)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205160",
    transform: "translate(25.425 4.807)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205161",
    transform: "translate(26.626 4.807)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205162",
    transform: "translate(23.021 2.404)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205163",
    transform: "translate(23.021 3.605)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205164",
    transform: "translate(24.223 4.807)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205165",
    transform: "translate(25.425 6.01)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 205166",
    transform: "translate(26.626 6.01)",
    style: {
      fill: "#76a9f4"
    },
    d: "M0 0h1.273v1.273H0z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeIntelzbot);
export default __webpack_public_path__ + "static/media/welcome_intelzbot.42976d2c930698cda8e648e3f47d7aa1.svg";
export { ForwardRef as ReactComponent };